var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0879 9.1493C10.6152 9.45661 10.0661 9.61906 9.50002 9.61906C8.93395 9.61906 8.38488 9.45661 7.91218 9.1493L0.126506 4.0875C0.0833107 4.05942 0.0412286 4.03015 0 4.00004V12.2943C0 13.2453 0.791359 14 1.74908 14H17.2509C18.2261 14 19 13.2283 19 12.2943V4C18.9587 4.03018 18.9165 4.05953 18.8732 4.08765L11.0879 9.1493Z",
    fill: "#EBBC13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.744043 2.91184L8.5297 7.72662C8.82442 7.90888 9.16219 8 9.49996 8C9.83777 8 10.1756 7.90885 10.4703 7.72662L18.256 2.91184C18.7219 2.6239 19 2.14199 19 1.62187C19 0.727548 18.2156 0 17.2515 0H1.74848C0.784381 3.44222e-05 0 0.727582 0 1.62273C0 2.14199 0.278172 2.6239 0.744043 2.91184Z",
    fill: "#EBBC13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2c5633a1d2769d25f9d85db94b75eaf4.svg";
export { ForwardRef as ReactComponent };